// Just a shortcut for bulk export

import parseLinkDestination from './parse_link_destination.mjs';
import parseLinkLabel from './parse_link_label.mjs';
import parseLinkTitle from './parse_link_title.mjs';

export { parseLinkDestination, parseLinkLabel, parseLinkTitle };
